import { render, staticRenderFns } from "./ArchivedAccountsTable.vue?vue&type=template&id=37e3b871"
import script from "./ArchivedAccountsTable.vue?vue&type=script&lang=js"
export * from "./ArchivedAccountsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports